<div class="unavailable-container">
      <img src="assets/images/technical-support.png" class="left-icon" alt="technical-support"/>
       <h1 [style.opacity]="flicker">{{'technical-difficulties'|translate}}</h1>
      <h4>{{'technical-difficulties-subhead'|translate}}</h4>
      <p>{{'technical-difficulties-1'|translate}}</p>
      <!-- <p>{{'technical-difficulties-2'|translate}}</p> -->
      <button (click)="checkForApp()" class="refresh-btn"> <img src="assets/images/refresh-page.png" alt="refresh page">{{'refresh'|translate}}</button>
</div>
